import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { logout } from '../../actions/authActions';
import { useDispatch } from 'react-redux';
import i18next from 'i18next';
import { Popover, Button, Divider, List, ListItem, ListItemIcon, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Logout, PersonOutlineOutlined } from '@mui/icons-material';
import UserProfile from '../Header/UserProfile';

interface DropdownProps {
  open: HTMLElement | null;
  toggle: (event: React.MouseEvent<HTMLElement>) => void;
}

const useStyles = makeStyles((theme) => ({
  user: {
    fontSize: '60px',
  },
  viewButton: {
    width: 'auto',
    color: 'white',
    backgroundColor: theme.palette.primary.main,
  },
  popover: {
    padding: '10px',
    width: '250px',
  },
  popoverContent: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '10px',
  },
  link: {
    textDecoration: 'none',
    color: 'inherit',
    display: 'flex',
    justifyContent: 'center',
    padding: '16px 24px',
  },
  divider: {
    margin: '10px 0',
  },
  listItem: {
    padding: '0',
    cursor: 'pointer',
  },
}));

const Dropdown: React.FC<DropdownProps> = ({ open: anchor, toggle }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [open, setPopOver] = useState<HTMLElement | null>(anchor);
  const [openProfileDialog, setOpenProfileDialog] = useState(false);
  const classes = useStyles();
  const dispatch = useDispatch();
  //@ts-ignore
  const onLogout = () => dispatch(logout());
  const handleProfileClick = () => {
    setOpenProfileDialog(true);
  };

  useEffect(() => {
    setPopOver(anchor);
  }, [anchor]);

  const handleToggle = (event: React.MouseEvent<HTMLElement>) => {
    toggle(event);
    setPopOver(null);
  };
  const handleCloseProfileDialog = () => {
    setOpenProfileDialog(false);
  };

  return (
    <>
      <Popover
        open={Boolean(open)}
        anchorEl={open}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        transformOrigin={{ horizontal: 'left', vertical: 'top' }}
        style={{ zIndex: 999999 }}
        onClose={() => handleToggle({} as React.MouseEvent<HTMLElement>)}
      >
        <div className={classes.popover}>
          <div className={classes.popoverContent}>
            <PersonOutlineOutlined className={classes.user} />
          </div>
          <Link
            to="/profile"
            className={classes.link}
            onClick={handleProfileClick}
          >
            <Button className={classes.viewButton} fullWidth variant="text" onClick={() => setPopOver(null)}>
              {i18next.t('common:settings.viewProfile')}
            </Button>
          </Link>

          <Divider className={classes.divider} />
          <List>
            <ListItem
              className={classes.listItem}
              onClick={() => onLogout()}>
              <ListItemIcon>
                <Logout />
              </ListItemIcon>
              <Typography data-cy="logout">{i18next.t('common:settings.logout')}</Typography>
            </ListItem>
          </List>
        </div>
      </Popover>
      <UserProfile open={openProfileDialog} onClose={handleCloseProfileDialog} />
    </>
  );
}

export default Dropdown;
